import {Spi} from "./src/Spi";
import {Logger} from './src/Logger';
import {Printer} from './src/Printing';

window.Spi = Spi;
window.Logger = Logger;
window.Printer = Printer;